import React, { useState, useEffect } from 'react';
import { Accordion, Icon } from 'semantic-ui-react';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function BottomAccordion(props) {
  const [activeIndicesStates, setActiveIndicesStates] = useState([]);

  const accordionHandleClick = (event, titleProps) => {
    const index = titleProps.index;
    let newIndexState = props.activeIndex;
    let foundIndex = newIndexState.findIndex((x) => {
      return x === index;
    });
    if (foundIndex === -1) {
      newIndexState.push(index);
    } else {
      newIndexState.splice(foundIndex, 1);
    }
    setActiveIndicesStates([...activeIndicesStates, newIndexState]);

    window.localStorage.setItem(`${props.pagePrefix}-${props.userId}`, JSON.stringify(newIndexState));
  };

  let activeIndexState = props.activeIndex;
  let accordionInnerMarkUp = props.options.map((option, index) => {
    let active = activeIndexState.includes(option.title.split(' ').join(''));
    let contentMarkUp = '';
    if (!!option.as) {
      if (option.as === 'custom') {
        contentMarkUp = <Accordion.Content active={active} content={option.content} />;
      }
      if (option.as === 'testCallBtn') {
        contentMarkUp = <TestCallBtnAccordionSessionContent active={active} title={option.title} link={option.link} />;
      }
    } else {
      contentMarkUp = (
        <Accordion.Content active={active}>
          {option.content.map((paragraph, i) => {
            return <p dangerouslySetInnerHTML={{ __html: paragraph }} key={i} />;
          })}
        </Accordion.Content>
      );
    }
    // Use title with no space as index. This version of Semantic UI does not accept string as index.
    // This warning will dismiss when updating Semantic UI in the future
    return (
      <div key={index}>
        <Accordion.Title active={active} index={option.title.split(' ').join('')} onClick={accordionHandleClick}>
          {active ? <b>{option.title}</b> : props.boldTitle ? <b>{option.title}</b> : option.title}
          {active ? (
            <Icon name="angle up" className="arrow-rotate-up" />
          ) : (
            <Icon name="angle up" className="arrow-rotate-down" />
          )}
        </Accordion.Title>
        {contentMarkUp}
      </div>
    );
  });
  return (
    <Accordion fluid styled id={props.id} className={props.className}>
      {accordionInnerMarkUp}
    </Accordion>
  );
}

export function TestCallBtnAccordionSessionContent(props) {
  return (
    <Accordion.Content active={props.active}>
      <a href={window.APP.CONFIGURATION.CURRENT_VCC_PAGE + props.link} target="_blank">
        <button type="button" id="vcc-div" className="ui labeled icon button right-hand-side-button">
          <Icon name="clipboard check" />
          {props.title}
        </button>
      </a>
    </Accordion.Content>
  );
}
